































import Vue from "vue";
import { VueConstructor } from "vue/types/vue";
export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      inputElement: HTMLInputElement;
    };
  }
>).extend({
  props: {
    puzzleName: {
      type: String,
      default: ""
    }
  },
  mounted() {
    
  },
  data() {
    return {
      submitName: this.puzzleName,
      update: false
    };
  },
  computed: {
    pname: function() : string{
      return this.submitName;
    }
  },
  methods: {
    updatePname: function(event: any) {
      this.submitName = event;
    },
    save: function(): void {
      this.$emit("save", this.submitName);
      this.$refs.inputElement.value = "";
      this.close();
    },
    close: function(): void {
      this.$emit("close");
    }
  },
  watch: {
    puzzleName: function(newval, oldval) {
      this.submitName = newval;
      this.update = true;
    }
  }
});
